import { MediaMessagesViewComponent } from '../../views/media-messages-view/media-messages-view.component';
import { AccessMenuTool } from './access-menu-tool';

export class MediaAccessMenuTool extends AccessMenuTool {
  public constructor() {
    super('Messages', 'chatbubbles', MediaMessagesViewComponent, 410);
  }
}
